require("@babel/polyfill");
require("./header.scss");

(()=>{
    'use strict';
    const subscribe = () => {
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
            const slot = event.slot;
            const element = document.getElementById(slot.getSlotElementId());
            if (element) {
                if (slot.getSlotElementId().includes('showroom_profile_home_header')) {
                    const container = document.getElementById('showroom_profile_home_header_container');
                    container.classList.add('slot-loaded');
                    container.classList.add('slot-' + (event.isEmpty ? 'empty' : 'full'));
                }
            }
        });
    }
    document.addEventListener('DOMContentLoaded', function () {
        window.googletag && googletag.cmd.push(subscribe);
    });
})();